import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseTableNew from 'components/atoms/base-table/new';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import PatientsReportIcon from 'components/atoms/icons/patientsReportIcon';

import { formatNumber } from './utils';

import type { IBaseTableColumnProps } from 'components/atoms/base-table/types';
import type { IPatientsReportRow } from './types';

interface IPatientsReportCardProps {
  data: IPatientsReportRow[];
  isLoading?: boolean;
  /** CSS module class names from the page */
  styles: Record<string, string>;
}

export const PatientsReportCard: React.FC<IPatientsReportCardProps> = ({
  data,
  isLoading = false,
  styles: s,
}) => {
  const { t } = useTranslation();

  const columns: IBaseTableColumnProps<IPatientsReportRow>[] = [
    {
      label: t('labels.patients'),
      key: 'label',
      align: 'left',
      render: (_, record) => record.label,
    },
    {
      label: t('labels.rpm'),
      key: 'rpm',
      align: 'center',
      render: (_, record) => formatNumber(record.rpm),
    },
    {
      label: t('labels.ccm'),
      key: 'ccm',
      align: 'center',
      render: (_, record) => formatNumber(record.ccm),
    },
    {
      label: t('labels.total'),
      key: 'total',
      align: 'center',
      tableCollClassName: s.totalColumn,
      render: (_, record) => formatNumber(record.total),
    },
  ];

  return (
    <div className={s.reportCard}>
      <div className={s.reportCardHeader}>
        <span className={s.reportCardIcon}>
          <PatientsReportIcon />
        </span>
        <span>{t('labels.patientsReport')}</span>
      </div>
      <BaseSpinWrapper spinning={isLoading}>
        <div className={s.reportCardBody}>
          <div className={s.patientsReportTable}>
            <BaseTableNew
              dataCy="provider-dashboard-patients-report"
              columns={columns}
              items={data}
              rowKey="key"
              bordered
              rowHoverable={false}
              changeOddRowColor
              rowClassName={s.reportRow}
            />
          </div>
        </div>
      </BaseSpinWrapper>
    </div>
  );
};
